import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { MaintenanceTypeSearchComponent } from './maintenance-type-search.component';

@NgModule({
    entryComponents: [
        MaintenanceTypeSearchComponent
    ],
    declarations: [
        MaintenanceTypeSearchComponent
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,

        MatAutocompleteModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule
    ],
    exports: [
        MaintenanceTypeSearchComponent
    ]
})
export class MaintenanceTypeSearchComponentModule {}
